"use client";
import { useScrollLock } from "@repo/lib/hooks/common";
import { IconCross } from "@repo/assets/images";
import { OverlayButton } from "@repo/ui";
import cx from "classnames";

const OffCanvasDrawer = ({
  open,
  handleClose,
  title,
  titleIcon,
  children,
  position,
}) => {
  useScrollLock({ lock: open });
  return (
    <div className="z-70 fixed">
      {open && <OverlayButton open={open} onClick={handleClose} />}
      <div
        className={cx(
          "z-70 fixed bottom-0 top-0 h-screen w-11/12 overflow-y-auto bg-white transition-all duration-300 md:w-[400px]",
          {
            "translate-x-full rtl:-translate-x-full":
              position === "right" && !open,
            "-translate-x-full rtl:translate-x-full":
              position === "left" && !open,
            "ltr:left-0 rtl:right-0": position === "left",
            "ltr:right-0 rtl:left-0": position === "right",
          }
        )}
      >
        {title && (
          <div className="flex items-center px-3 py-2">
            {titleIcon && <span>{titleIcon}</span>}
            {title && (
              <span className="font-heading text-supportiveBlack rtl:font-arabic text-xl font-medium md:text-4xl">
                {title}
              </span>
            )}

            <button
              type="button"
              className="ms-auto border-0 p-0"
              onClick={handleClose}
              name={`close ${title || "drawer"}`}
              aria-label={`close ${title || "drawer"}`}
            >
              <IconCross className="text-miniSearch-icon w-4 cursor-pointer fill-current font-bold" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default OffCanvasDrawer;
